import BannerBtcDiscountShoppingCart from './banner-btc-discount-shopping-cart';

export default BannerBtcDiscountShoppingCart;
